var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08592 0.55127H13.6727C14.5913 0.55127 15.3279 1.29613 15.3279 2.20652V8.06611C14.0451 7.85093 12.7788 8.14887 11.7526 8.82753H8.70692V12.138H9.60076C9.50972 12.7008 9.50972 13.2553 9.60076 13.7933H2.08592C1.17553 13.7933 0.430664 13.0567 0.430664 12.138V2.20652C0.430664 1.29613 1.17553 0.55127 2.08592 0.55127ZM2.08592 3.86177V7.17227H7.05167V3.86177H2.08592ZM8.70692 3.86177V7.17227H13.6727V3.86177H8.70692ZM2.08592 8.82753V12.138H7.05167V8.82753H2.08592ZM14.8645 15.4485V13.7933H11.554V12.138H14.8645V10.4828L17.3473 12.9657L14.8645 15.4485Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.d2324cbfd74cf0194802c94c2487e19e.svg";
export { ForwardRef as ReactComponent };